import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaHome, FaUser, FaMoneyBillWave, FaChartLine, FaHandHoldingUsd, FaHistory, FaPhone, FaCoins, FaSignOutAlt } from 'react-icons/fa';
import { signOut } from 'firebase/auth';
import { auth } from '../../Config/Config';

const Sidebar = ({ isOpen, onClose }) => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth); // Use the imported auth directly
      navigate('/login');
      onClose();
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  return (
    <aside 
      className={`fixed inset-y-0 left-0 transform ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } md:translate-x-0 md:static md:inset-auto md:w-64 w-64 transition-transform duration-200 ease-in-out bg-[#000300] text-white z-50`}
      style={isMobile ? { zIndex: 90 } : {}}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between p-4 border-b border-[#fff] lg:border-transparent md:border-transparent lg:pt-16 md:pt-16">
        <span className="text-lg font-bold lg:hidden md:hidden lg:pl-4 md:ml-4 ml-6 text-[#fff]">Dashboard</span>
        <button 
          onClick={onClose} 
          className="text-white text-2xl md:hidden">
          &times;
        </button>
      </div>

      {/* Navigation Links */}
      <nav className="mt-8 text-[#fff]">
        <ul>
          <li>
            <Link to="/dashboard" className="flex items-center px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3" onClick={onClose}>
              < FaCoins className="mr-3" />
              Overview
            </Link>
          </li>
          <li>
            <Link to="/dashboard/profile" className="flex items-center px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3" onClick={onClose}>
              <FaUser className="mr-3" />
              Profile
            </Link>
          </li>
          <li>
            <Link to="/dashboard/deposit" className="flex items-center px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3" onClick={onClose}>
              <FaMoneyBillWave  className="mr-3" />
              Deposit
            </Link>
          </li>
          <li>
            <Link to="/dashboard/investmentplans" className="flex items-center px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3" onClick={onClose}>
              <FaChartLine  className="mr-3" />
              Investment Plans
            </Link>
          </li>
          <li>
            <Link to="/dashboard/withdraws" className="flex items-center px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3" onClick={onClose}>
              <FaHandHoldingUsd  className="mr-3" />
              Withdraw
            </Link>
          </li>
          <li>
            <Link to="/dashboard/history" className="flex items-center px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3" onClick={onClose}>
              <FaHistory  className="mr-3" />
              History
            </Link>
          </li>
          
          {/* Logout Button */}
          <li>
            <button 
              onClick={handleLogout}
              className="flex items-center w-full px-4 py-2 hover:bg-gray-700 font-semibold text-lg py-3"
            >
              <FaSignOutAlt className="mr-3" />
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;